// pre-chat-lead.ts — zod schema for the public pre-chat lead form endpoint (prechat-persona
// spec §1). Mirrors `publicChatSchema`'s `sessionKey` bounds (the widget generates the same
// session key for both the form and the chat that follows it) and `publicLeadSchema`'s
// `email`/`name`/`phone` bounds.
import { z } from 'zod';

export const preChatLeadSchema = z.object({
  sessionKey: z.string().min(8).max(100),
  name: z.string().max(80).optional(),
  email: z.string().email(),
  phone: z.string().trim().min(1).max(40).optional(),
});
